import React from 'react';
import {
  Button, Card, CardBody, Progress, Modal, ModalFooter, ModalHeader, ModalBody
} from 'reactstrap';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
//react-redux comm
import { connect } from 'react-redux';
import { store  } from '../../_helpers';
import SearchPanel from './match-domestic-paymentpanel';
import PaginatedResult from './matched-records';
import {Link} from 'react-router-dom';


// styling
import './style.css';

// Actions
import { commonActions, apiActions,alertActions } from '../../_actions';
import {appConstants} from "../../_constants";
import { appHelpers } from '../../_helpers';
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import {commonService} from "../../_services";
import CheckIcon from 'react-icons/lib/md/info';
import CheckSuccess from 'react-icons/lib/md/check-circle';


let activeUser = appHelpers.getActiveUser();

const ViewHeader = () => (
    <div className="view-header d-flex align-items-center">
        <header className="text-white">
            <h1 className="h5 title text-uppercase">Match Domestic Payment</h1>
            {/* <p className="mb-0 subtitle text-nowrap">Statement of TSC</p> */}
        </header>
    </div>
);
const ViewContent = ({children}) => (
    <div className="view-content view-components">
        {children}
    </div>
);

class TSC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            matchedPayments: [],
            activeReconciliation: null,
            activeUser: activeUser,
            airlineName:null,
            startDate: new Date(),
            endDate: new Date(),
            url:`${appConstants.PAS_URL}/api/Aggregate/StatementOfTscReport`,
            excelUrl: `${appConstants.PAS_URL}/api/Aggregate/DownloadStatementOfTscReport?DownloadTypeId=1&AirlineName=`,
            catOptions: [],
            searchOptions: [],
            //searchArray: [{ label: 'Flight Date', value: 1, cat: 'DateType' }],
            searchArray: [{ label: 'Invoice Date', value: 202, cat: 'DateType' }],
            searchLabelKey: '',
            searchValueKey: '',
            airlines: [],
            selectValue: { label: 'Date Type', value: 'DateType' },
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true
            },
            records: false,
            modal: false,
            modalClass: '',
            pdfRecords:null,
            excelRecords:null,
            contentErrorText:false,
            passengerDetails: false,
            pageSize: 10,
            currentPage: 0,
            totalFlightCounts: 1,
            totalMatchPaymentsCount: 0,
            selectCategories: [],
            unmatchedInvoiceNumber: '',
            aggregateInvoiceNumber: '',
            matchSuccess: false
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }

    componentWillMount() {
        this.setCategories();

    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        //    Fetch Airlines
        const reduxState = store.getState();
        if (reduxState.airlinesCarriers) {
            const localAirlines = reduxState.airlinesCarriers.Results.filter(item => item.IsLocal);
            this.setState({airlines: this.formatAirlines(localAirlines)});
        } else {
            this.fetchAirlines();
        }
        // this.setState({activeUser: appHelpers.getActiveUser()});

        //Get today's records results

        // this.search();
        const  queryString = window.location.href.split('/');
        // console.log('queryString', queryString);
        this.setState({unmatchedInvoiceNumber: queryString[queryString.length - 1]})
    }

    toggleModal = () => {
        this.setState({ modal: !this.state.modal});
   };

    componentDidUpdate(prevProps, prevState) {
        const { clickBD } = this.state;
        if (clickBD) {
            // debugger;
            this.search(1);
            this.setState({ clickBD: false });
        }
    }

    setCategories = () => {
        const activeUser  = appHelpers.getActiveUser();
        let cat;
        if (activeUser.AirlineCode != null){
            cat = [
                { label: 'Date Type', value: 'DateType' },
                { label: 'Payment Status', value: 'PaymentStatus' },
            ];

        }else{
            cat = [
                { label: 'Date Type', value: 'DateType' },
                { label: 'Payment Status', value: 'PaymentStatus' },
            ] ;
        }
        this.setState({catOptions : cat})
    }
    //update selected category
    updateCatValue = (newValue) => {
        this.setState({
            selectValue: newValue
        });
        this.handleCatChange(newValue);
    }

    // remove option if option in that category is already selected
    switchOptionsPerCategory = (currentArray, newArray, category) => {
        const { selectValue } = this.state;
        let currentCat = (category)? category : selectValue;
        let optionToReplace = currentArray.filter(option => option.cat === currentCat.value)[0];
        if (optionToReplace) {
            return newArray.filter(option => option.label !== optionToReplace.label);
        } else {
            return newArray;
        }
    }

    //update selected options categories
    handleSelectChange = (newValue, category) => {
        let currentArray = this.state.searchArray;
        //debugger;
        let newArray = (currentArray.length > 0) ? this.switchOptionsPerCategory(this.state.searchArray, newValue, category) : newValue;
        this.setState({ searchArray: newArray });
    }

    fetchAirlines = () => {
        const {dispatch} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                const { airlinesCarriers } = this.props;
                const localAirlines = airlinesCarriers.Results.filter(item => item.IsLocal);
                this.setState({airlines: this.formatAirlines(localAirlines)});
                //this.formatAirlines(res.data.Results);
                dispatch(apiActions.endRequest());
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
            dispatch(apiActions.endRequest());
        });
    }

    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    converter = (item) => {
        const { airlinesCarriers } = this.props;
        const filteredAirline =  airlinesCarriers.Results.filter(airline => {
            return airline.Id === item;
        });
        return filteredAirline[0].Name;

    }
    formatSearchParameters = (res) => {
        const activeUser  = appHelpers.getActiveUser();
        if(res.length > 0) {
            let searchParameters = {};
            res.map(parameter =>
                searchParameters[parameter.cat] = parameter.value
            );
            /*Cater for Airline Users */
            if (activeUser.AirlineCode != null){
                searchParameters.AirlineId = activeUser.AirlineId;
            }
            return searchParameters;
        }
        return {};
    };


    notify = (message, level) => {
        let notification = this.state.notification;
        notification['message'] = message;
        notification['level'] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(notification);
    };

    onRemove = (notification) => {
        if (this._lastNotificationAdded && notification.uid === this._lastNotificationAdded.uid) {
            this._lastNotificationAdded = null;
        }
    };

    search = (pageNumber) => {
        const { dispatch } = this.props;
        const { pageSize, startDate, endDate } = this.state;

            this.setState({contentError: false});
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            pageNumber = 1;
        }else{
            dispatch(apiActions.startRequest());
        }

        let fromPage = pageSize * (pageNumber - 1);

        // if((pageNumber - 1) > 0) {
        //     fromPage = 1;
        // }
        // let searchParams = this.formatSearchParameters(searchArray);
        let searchParams = {DateType: 202, PaymentStatus: 2}
        //  console.log('searchparams', searchParams);
        let payload = {
            "PageSize": pageSize,
            "From": fromPage,
            "Parameter": {
                ...searchParams,
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59"
            }
        };
        let url = this.state.url;
        appHelpers.postRequest(url, payload,{})
            .then((res) => {

                this.setState({
                    records: res.data,
                    currentPage: pageNumber
                });
                dispatch(apiActions.endRequest());
            })
            .catch((error) => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                //dispatch(alertActions.error(errorMessage));
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                dispatch(apiActions.endRequest());
                this.setState({contentError: errorMessage})
            });
    };


    downloadPdfAndExcel = (downloadType) => {
        const { dispatch } = this.props;
        const { searchArray, startDate, endDate } = this.state;
        let searchParams = this.formatSearchParameters(searchArray);
        const payload__ = {
            "PageSize": 100,
            "From": 1,
            "Parameter": {
                ...searchParams,
                StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
                EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59"
            }
        };

        commonService.downloadPdfAndExcel(payload__, downloadType)
            .then((res) => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    let response = res.response.data.File;

                    window.open(response, '_blank');
                    dispatch(apiActions.endRequest());
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }

            });

        dispatch(apiActions.startRequest());
    };

    renderPageResponse() {
        if(this.state.error){
            return (<div className="alert alert-danger">{this.state.error}</div>);
        }
        else if(this.state.componentError){
            return (<div className="alert alert-danger">{this.state.componentError}</div>);
        }
        else if(this.state.success){
            return (<div className="alert alert-success">{this.state.success}</div>);
        }
    }

    fetchMatchingPayment = (pageNumber) => {
        const {FileId, activeReconciliation} = this.state;
        const {dispatch} = this.props;
        let { pageSize } = this.state;
        let fromIndex;
        if(pageNumber === undefined){
            dispatch(apiActions.startFullPageRequest());
            fromIndex = 0;
            pageNumber = 1;
        }else{
            fromIndex = pageSize * (pageNumber -1);
            dispatch(apiActions.startRequest());

        }
         let payload = { PageSize: 10, From: fromIndex};
        payload.Parameter = {
            FileId: FileId, LocationCode: activeReconciliation.AccountCode,
            Currency: activeReconciliation.Currency,
            BilledAmount: activeReconciliation.NetAmountCurrency
        };

        commonService.getMatchingPayments(payload)
            .then((res) => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({currentPage: pageNumber, matchedPayments: res.response.Results, totalMatchPaymentsCount: res.response.TotalCount });
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(apiActions.endRequest());
                }
            });

    };

    getReconciliationById = (reconId) => {
        commonService.getReconciliationById({Id: reconId})
            .then(res => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                     if(res.response.Found){
                        this.setState({ activeReconciliation: res.response.Source});
                    }else{
                        this.notify('Invalid Reconciliation File', appConstants.NOTIFY_ERROR);
                    }
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                }
            });
    };

    matchPaymentAction = (billedDetails) => {

        this.setState({
            aggregateInvoiceNumber: billedDetails.InvoiceNumber
        })
        this.toggleModal();
        // console.log(billedDetails);
    }

    confirmedMatchPaymentAction = () => {
        let { dispatch } = this.props;
        const { unmatchedInvoiceNumber, aggregateInvoiceNumber } = this.state;
        // console.log(aggregateInvoiceNumber, unmatchedInvoiceNumber);
        dispatch(apiActions.startRequest());
        const payload = {
            "Parameter": {
                UnmatchedInvoiceNumber: unmatchedInvoiceNumber,
                AggregateInvoiceNumber: aggregateInvoiceNumber
            }
        }
        commonService.processUnmatchedDomesticPayment(payload)
            .then(res => {
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    // this.toggleModal();
                    dispatch(apiActions.endRequest());
                    this.notify('Payment matched successfully', appConstants.NOTIFY_SUCCESS);
                    // window.location.href = '/unmatched-domestic-payment';
                    this.setState({matchSuccess: true})
                 }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    this.toggleModal();
                    this.notify('Failed to match payment', appConstants.NOTIFY_ERROR);
                            dispatch(apiActions.endRequest());
                }
            });
    }

    render() {
        const {contentErrorText,catOptions,  selectValue, searchOptions, searchLabelKey, searchValueKey, searchArray, contentError, currentPage, pageSize, records, error } = this.state;
        const { requesting, pageRequesting } = this.props;
        return (
            <div className="view">
                <ViewHeader/>
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        { ((pageRequesting || requesting) && !pageRequesting ) && <Progress striped animated color="success" value={100} className="mb-2"/> }
                        {/*Display loader when component content is dependent on Data from API*/}
                        { (!contentError && pageRequesting) &&
                        <PageLoading/>
                        }

                        {/*Display error when component fail to get Data from API*/}
                        { contentError &&
                        <PageError error={this.state.contentError }/>
                        }

                        {/*Display component content when Data is gotten from API*/}

                        { (!contentError && !pageRequesting) &&
                        <CardBody>
                            <h6 className="mb-4 text-uppercase">Search Panel</h6>
                            <SearchPanel
                                contentErrorText={contentErrorText}
                                categories={catOptions}
                                selectedCat={selectValue}
                                multiOptions={searchOptions}
                                multiLabelKey={searchLabelKey}
                                multiValueKey={searchValueKey}
                                multiArray={searchArray}
                                onCatValueChange={this.updateCatValue}
                                onMultiValueChange={this.handleSelectChange}
                                onSearch={this.search}
                                startDateChange={startDate => this.setState({ startDate })}
                                endDateChange={endDate => this.setState({ endDate })} />

                            {/*Files to be downloaded*/}
                            {/*{(!pageRequesting && records) &&*/}
                            {/*<div className="col-sm-12 text-right">*/}
                            {/*<strong>Download: </strong>*/}
                            {/*<span className="pointer" onClick={()=> this.downloadPdfAndExcel(commonConstants.PDF_DOWNLOAD_TYPE)}>*/}
                            {/*<ToolTipItem key={'downloadPdfIcon'} title={<PdfIcon size="18" color="#e53335" className="icon-picture-as-pdf"/>} content='Download PDF' id={'downloadPdfIcon'}/>*/}
                            {/*</span>*/}
                            {/*&nbsp;<span className="pointer" onClick={()=> this.downloadPdfAndExcel(commonConstants.EXCEL_DOWNLOAD_TYPE)}>*/}
                            {/*<ToolTipItem key={'downloadExcelIcon'} title={<ExcelIcon size="18" color="#5ead57" className="icon-insert-drive-file"/>} content='Download Excel' id={'downloadExcelIcon'}/>*/}
                            {/*</span>*/}
                            {/*</div>*/}
                            {/*}*/}
                            <CardBody>

                                {(!pageRequesting && records) &&
                                <div>
                                    <PaginatedResult
                                        downloadFile = {this.downloadPdfAndExcel}
                                        recordResults={records}
                                        currentPage={currentPage}
                                        navigate={this.search}
                                        pageSize={pageSize}
                                        totalCount={records.TotalCount}
                                        showrecord={this.showrecord}
                                        converter = {this.converter}
                                        matchCallback={this.matchPaymentAction}
                                    />
                                </div>
                                }

                                {(!pageRequesting && !records) &&
                                <PageEmptyContent message='No record match your search!'/>
                                }
                            </CardBody>
                        </CardBody>
                        }

                        {/* Confirmation Modal */}
                         <Modal size={'sm'} isOpen={this.state.modal} toggle={this.toggleModal} className={this.state.modalClass}>
                            <ModalHeader toggle={this.toggleModal}> Match Payment</ModalHeader>
                            <ModalBody>

                                { this.state.matchSuccess &&
                                <div>
                                     <div className="text-center">
                                      <CheckSuccess size="50" color="#00897b"/>
                                     </div>
                                    <h5 className='text-center mb-3'>Payment matched successfully</h5>
                                    </div>
                                }


                                { !this.state.matchSuccess &&
                                   <div>
                                       <div className="text-center">
                                       <CheckIcon size="50"/>
                                       </div>
                                    {
                                    error &&
                                        <div className="alert alert-danger text-center">{error}</div>
                                    }
                                    <h5 className='text-center mb-3'>Are you sure you want to match this payment?</h5>
                                   </div>
                                }

                            </ModalBody>
                            <ModalFooter>
                            { this.state.matchSuccess &&
                            <div>
                                <Link to={`/unmatched-domestic-payment`}>
                                  <Button className="btn-avi-secondary center" disabled={ requesting } onClick={this.confirmedMatchPaymentAction} > Ok </Button>{' '}
                                </Link>
                            </div>
                            }
                            {!this.state.matchSuccess &&
                              <div>
                                 <Button className="btn-avi-primary" disabled={ requesting } onClick={this.confirmedMatchPaymentAction} > Confirm </Button>{' '}
                                <Button color="secondary" disabled={ requesting } onClick={this.toggleModal}> Cancel </Button>{' '}
                              </div>
                            }

                            </ModalFooter>
                            { requesting &&  <div className="loading-dot active">&nbsp;</div>}
                        </Modal>


                        <NotificationSystem ref="notificationSystem"/>
                    </Card>
                </ViewContent>
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        airlinesCarriers: state.airlinesCarriers,
        requesting: state.api.requesting,
        pageRequesting: state.api.pageRequesting
    };
}

export default connect(mapStateToProps)(TSC);



// WEBPACK FOOTER //
// ./src/views/matchDomesticPayment/index.js